/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarButtons_viewer = {
    readonly soldHoldPdpSourcingModal: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedContactDealerButton_viewer">;
    readonly " $refType": "PdpRespSidebarButtons_viewer";
};
export type PdpRespSidebarButtons_viewer$data = PdpRespSidebarButtons_viewer;
export type PdpRespSidebarButtons_viewer$key = {
    readonly " $data"?: PdpRespSidebarButtons_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarButtons_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespSidebarButtons_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "soldHoldPdpSourcingModal",
      "name": "featureFlag",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "soldHoldPdpSourcingModal"
        }
      ],
      "storageKey": "featureFlag(feature:\"soldHoldPdpSourcingModal\")"
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedContactDealerButton_viewer",
      "args": null
    }
  ]
};
(node as any).hash = 'd8ca90c89ae84cdb555c58048fe9f9fe';
export default node;
